<div class="config-market-account-container">
  <div class="title-row" mat-dialog-titled>
    <h2 mat-dialog-title>
      <span>{{ "settings.account.info.title-market-account-dialog" | translate }}</span>
    </h2>
    <span class="close-btn" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <mat-dialog-content>
    <ng-container>
      <mat-radio-group aria-label="Select an option" [(ngModel)]="dataDomain.selectedOption" (ngModelChange)="selectConfigDomain()">
        <mat-radio-button [value]="DomainDataConfig.TopDomain" class="newList-section">
          <span class="radio-label">{{ "settings.account.info.top-level-domain" | translate }}</span>
          <div>
            <span class="prefix-label">{{ dataDomain.topDomain.prefix }}</span>
            <mat-form-field appearance="outline" class="new-style-input">
              <input
                matInput
                placeholder="se"
                [(ngModel)]="dataDomain.topDomain.name"
                [disabled]="dataDomain.selectedOption !== DomainDataConfig.TopDomain"
                (input)="validateDomain()" />
              @if (dataDomain.errors?.topDomain) {
                <mat-hint class="error">{{ dataDomain.errors?.topDomain | translate }}</mat-hint>
              }
            </mat-form-field>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="DomainDataConfig.SubDomain" class="existedList-section">
          <span class="radio-label">{{ "settings.account.info.sub-directory" | translate }}</span>
          <div>
            <span class="prefix-label">{{ dataDomain.subDomain.prefix }}</span>
            <mat-form-field appearance="outline" class="new-style-input">
              <input
                matInput
                placeholder="se"
                [(ngModel)]="dataDomain.subDomain.name"
                [disabled]="dataDomain.selectedOption !== DomainDataConfig.SubDomain"
                (input)="validateDomain()" />
              @if (dataDomain.errors?.subDomain) {
                <mat-hint class="error">{{ dataDomain.errors?.subDomain | translate }}</mat-hint>
              }
            </mat-form-field>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <ng-container>
      <button
        [disabled]="dataDomain.errors || isDataDomainEmpty"
        mat-stroked-button
        class="primary-button"
        (click)="saveChanges()"
        class="primary-button btn-size-l"
        mat-dialog-close>
        <span>{{ "generic.save" | translate }}</span>
      </button>
    </ng-container>
  </mat-dialog-actions>
</div>
